/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_SYSTEM_PARAMETER = 'GET_SYSTEM_PARAMETER';
export const GET_DEFAULT_AUDIT = 'GET_DEFAULT_AUDIT';
export const GET_DEFAULT_SYSTEM_PARAMETER = 'GET_DEFAULT_SYSTEM_PARAMETER';
export const GET_GENERAL_SYSTEM_PARAMETER = 'GET_GENERAL_SYSTEM_PARAMETER';
export const GET_DEFAULT_UNIT_TYPE_AUDIT = 'GET_DEFAULT_UNIT_TYPE_AUDIT';
export const GET_HOLIDAY = 'GET_HOLIDAY';
export const SET_HOLIDAY = 'SET_HOLIDAY';
export const GET_MD_SPEC_THERA = 'GET_MD_SPEC_THERA';
export const SET_SPEC_IN_SYS = 'SET_SPEC_IN_SYS';
export const SET_NM_ACC_IN_SYS = 'SET_NM_ACC_IN_SYS';
export const SET_NM_FIN_IN_SYS = 'SET_NM_FIN_IN_SYS';
export const SET_MD_SPEC_THERA = 'SET_MD_SPEC_THERA';
export const GET_NM_FIN_CODE = 'GET_NM_FIN_CODE';
export const GET_NM_FIN_CODE_UPDATE = 'GET_NM_FIN_CODE_UPDATE';
export const MAX_DT_AR_ACTIVITY = 'MAX_DT_AR_ACTIVITY';
export const GET_NM_ACCOUNT_NUMBER = 'GET_NM_ACCOUNT_NUMBER';
export const UPDATE_NM_ACCOUNT_NUMBER = 'UPDATE_NM_ACCOUNT_NUMBER';
export const UPDATE_SYSTEM_PARAM = 'UPDATE_SYSTEM_PARAM';
export const UPDATE_NM_FINE_CODE = 'UPDATE_NM_FINE_CODE';
export const UPDATE_MD_SPEC_THERA = 'UPDATE_MD_SPEC_THERA';
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY';
export const SET_SYSTEM_PARAMETER_PAYLOAD = 'SET_SYSTEM_PARAMETER_PAYLOAD';
export const SET_DEFAULT_AUDIT_DATA = 'SET_DEFAULT_AUDIT_DATA';
export const SET_GEN_SYS_PARAM_DATA = 'SET_GEN_SYS_PARAM_DATA';
export const SET_DEF_SYS_PARAM_DATA = 'SET_DEF_SYS_PARAM_DATA';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_SUCCESS_MESSAGES = 'SET_SUCCESS_MESSAGES';
export const SET_TAB_VALUE = 'SET_TAB_VALUE';
export const SET_DISABLED_SAVE_CANCEL_BTN = 'SET_DISABLED_SAVE_CANCEL_BTN';
export const RESET_SYSTEM_PARAMETER_STORE = 'RESET_SYSTEM_PARAMETER_STORE';
export const SELECTED_UNIT_DEFAULT_CODE = 'SELECTED_UNIT_DEFAULT_CODE';
export const VALIDATE_NMACCOUNT_NUMBER = 'VALIDATE_NMACCOUNT_NUMBER';
export const VALIDATE_NMFIN_CODE = 'VALIDATE_NMFIN_CODE';
export const UPDATE_DEFAULT_AUDIT_DATA = 'UPDATE_DEFAULT_AUDIT_DATA'
